export default "__VITE_ASSET__hc4$YBlS__"